import React from "react";
import InputProjects from "./InputProjects";
import { ActionIcon } from "@mantine/core";
import { FaSun, FaMoon } from "react-icons/fa";
import { FaBell } from "react-icons/fa6";

const HeaderProjects = ({
  searchOpen,
  handleSearchOpen,
  searchTrendingRef,
  isScrolled,
  toggleColorScheme,
  computedColorScheme,
  handleSearchMobile,
  isSearchMobile,
  setIsSearchMobile,
  projects,
}) => {
  return (
    <>
      <header
        className={`${
          !isScrolled
            ? "hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light-80 dark:bg-background-dark-80 sticky  z-sticky top-0"
            : "hidden sm:block backdrop-blur-lg transition-colors -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 sticky  z-sticky top-0"
        }`}
      >
        <div className="flex h-[5rem] w-full items-center justify-between gap-8 text-neutral-100 dark:text-neutral-0">
          <InputProjects
            projects={projects}
            searchOpen={searchOpen}
            handleSearchOpen={handleSearchOpen}
            searchTrendingRef={searchTrendingRef}
            computedColorScheme={computedColorScheme}
          />

          <div className="flex items-center gap-2">
            <ActionIcon variant="light" color="gray" size="lg">
              <FaBell />
            </ActionIcon>
            <ActionIcon
              variant="light"
              color="gray"
              size="lg"
              onClick={toggleColorScheme}
            >
              {computedColorScheme === "dark" ? <FaSun /> : <FaMoon />}
            </ActionIcon>
          </div>
        </div>
      </header>
      {!isSearchMobile ? (
        <header className="sticky top-0 z-sticky sm:hidden -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 bg-background-light-80 dark:bg-background-dark-80 backdrop-blur-none ">
          <div className="py-4">
            <div className="flex h-16 w-full items-center gap-3 rounded-xl border border-n-20 bg-n-0 px-3 py-2 shadow-lg shadow-black-5 dark:shadow-black-40">
              <div className="shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                  className="text-primary-main"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <circle
                    cx="116"
                    cy="116"
                    r="84"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                  ></circle>
                  <line
                    x1="175.4"
                    y1="175.4"
                    x2="224"
                    y2="224"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="16"
                  ></line>
                </svg>
              </div>
              <div
                className="flex grow flex-col items-start"
                onClick={handleSearchMobile}
              >
                <h1 className="text-base font-medium leading-6 text-n-100">
                  Pre-Launch Leaderboard
                </h1>
                <span className="text-xs text-n-50">
                  Search by project, exchange, or wallet
                </span>
              </div>
            </div>
          </div>
        </header>
      ) : (
        <header className="sticky top-0 z-sticky sm:hidden -mx-4 px-4 sm:-mx-8 sm:px-8 2xl:-mx-16 2xl:px-16 transition-colors border-b border-b-black-10 bg-neutral-10 dark:bg-neutral-100 dark:border-b-white-10">
          <div className="flex w-full items-center justify-between gap-4 h-[4rem]">
            <div className="flex min-w-0 grow items-center gap-2">
              <svg
                onClick={handleSearchMobile}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 256 256"
                className="flex-shrink-0 cursor-pointer text-neutral-30"
              >
                <rect width="256" height="256" fill="none"></rect>
                <line
                  x1="216"
                  y1="128"
                  x2="40"
                  y2="128"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="16"
                ></line>
                <polyline
                  points="112 56 40 128 112 200"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="16"
                ></polyline>
              </svg>
              <div className="min-w-0 grow text-base font-semibold text-neutral-0">
                <div className="flex items-center gap-1 rounded-lg border border-n-20 bg-n-5 px-3 py-[0.5625rem] transition focus-within:border-n-100  focus-within:ring focus-within:ring-secondary-focus hover:border-n-100 dark:focus-within:ring-secondary-focus-dark">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                    className="text-n-70"
                  >
                    <rect width="256" height="256" fill="none"></rect>
                    <circle
                      cx="116"
                      cy="116"
                      r="84"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="16"
                    ></circle>
                    <line
                      x1="175.4"
                      y1="175.4"
                      x2="224"
                      y2="224"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="16"
                    ></line>
                  </svg>
                  <input
                    className="w-full bg-n-5 text-base font-normal text-n-100 placeholder-n-40 transition-colors placeholder:text-sm focus:outline-none sm:text-sm"
                    maxlength="75"
                    placeholder="Search by project, exchange, or wallet"
                    spellcheck="false"
                    autocomplete="off"
                    id="headlessui-combobox-input-:r43m:"
                    role="combobox"
                    type="search"
                    aria-expanded="false"
                    aria-autocomplete="list"
                    data-headlessui-state=""
                    value=""
                  />
                </div>
              </div>
            </div>
          </div>
        </header>
      )}
    </>
  );
};

export default HeaderProjects;
